import { RootState } from "..";

// Locator lengths & types related
export const getLocatorFetchStatus = (state: RootState) =>
  state.LocatorReducer.locatorFetchStatus;

export const getLocatorsLengths = (state: RootState) =>
  state.LocatorReducer.locatorLengths;

export const getLocatorsTypes = (state: RootState) =>
  state.LocatorReducer.locatorTypes;

export const getLocatorData = (state: RootState) =>
  state.LocatorReducer.locatorData;

// Uploading locator image
export const getLocatorUploadStatus = (state: RootState) =>
  state.LocatorReducer.locatorUploadStatus;

export const getUploadedLocatorData = (state: RootState) =>
  state.LocatorReducer.uploadedLocatorData;

// Adding locator to dataset
export const getUploadedLocatorStatus = (state: RootState) =>
  state.LocatorReducer.addNewLocatorStatus;

export const getActiveLocator = (state: RootState) =>
  state.LocatorReducer.activeLocator;

export const getLocatorUpdateStatus = (state: RootState) =>
  state.LocatorReducer.locatorUpdateStatus;

export const getLocatorFilters = (state: RootState) =>
  state.LocatorReducer.locatorFilters;

export const getLocatorsAmount = (state: RootState) =>
  state.LocatorReducer.locatorsTotalAmount;
